import ProgressBarRoot from './components/progress-bar-root'
import ProgressBarHeader from './components/progress-bar-header'
import ProgressBarBar from './components/progress-bar-bar'
import ProgressBarFooter from './components/progress-bar-footer'
import ProgressBarLabel from './components/progress-bar-label'

const ProgressBarComponent = {
  Root: ProgressBarRoot,
  Header: ProgressBarHeader,
  Bar: ProgressBarBar,
  Footer: ProgressBarFooter,
  Label: ProgressBarLabel
}

export default ProgressBarComponent
